import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Trans, useTranslation } from 'react-i18next';

import InfoIconPrimary from '../../../../../../../../assets/icons/InfoIconPrimary';
import generateEmailBody from '../../../../../../../../components/download-pcf/generateEmailBody';
import { useAuth } from '../../../../../../../../hooks/auth/useAuth';
import { Locale } from '../../../../../../../../i18n';
import { SUPPORT_EMAIL } from '../../../../../../../../shared/constants/emails.constant';

const InfoMessage = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { user } = useAuth();

  const openUpdateInquiryEmail = () => {
    const emailSubject = t('emails.upgradeInquiry.subject');
    let emailBody = generateEmailBody(user, language as Locale);

    // Encode the email body for the mailto link
    emailBody = encodeURIComponent(emailBody);

    // Create the mailto link with the recipient, subject, and body
    const mailtoLink = `mailto:${SUPPORT_EMAIL}?subject=${emailSubject}&body=${emailBody}`;

    // Open the user's default email client with the mailto link
    window.location.href = mailtoLink;
  };

  return (
    <Message
      severity='info'
      className='border-round-2xl bg-primary-100 w-full'
      content={
        <div className='flex flex-row w-full'>
          {/* Icon */}
          <div className='mr-2'>
            <InfoIconPrimary width={20} height={20} />
          </div>

          {/* Text */}
          <div className='flex flex-column'>
            <div className='text-lg font-medium mb-2 text-primary'>
              {t('productDetailsPage.tabs.pcfTab.infoMessage.title')}
            </div>
            <div className='flex flex-column gap-2 text-black-alpha-90'>
              <span>{t('productDetailsPage.tabs.pcfTab.infoMessage.content1')}</span>

              <span>
                <Trans
                  i18nKey='productDetailsPage.tabs.pcfTab.infoMessage.content2'
                  components={[
                    <Button
                      link
                      key={0}
                      className='p-0 text-primary underline'
                      onClick={openUpdateInquiryEmail}
                    />,
                  ]}
                />
              </span>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default InfoMessage;
